// extracted by mini-css-extract-plugin
module.exports = {"multiSiteCell":"create-service_multiSiteCell__38YaV","form":"create-service_form__2k-fp","gridArea":"create-service_gridArea__oK0Yi"};